import React from 'react';
import { Loading, Text, Button } from '../../components';
import { keyUpOnlyNumber } from '../../utils/formatter';

const AnesthetistQuestionaryForm = ({ loading, questionaryFields, onToggleField, values, variant, patient, onSubmit, onSkip, height, weight, onHeightChange, onWeightChange, isMobile }) => {
	if (loading) {
		return <Loading />;
	}

	return (
		<div className="doca-flex doca-flex-col doca-w-full">
			<div className="doca-mb-4 doca-mt-6 doca-px-4">
				<label className="doca-steps__label">
					Passo 1 de 3
				</label>

				<div className="doca-steps__container">
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--current doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--${variant}`} />
				</div>
			</div>

			<div className="doca-px-4">
				<Text size="large" weight="medium" marginBottom={16}>
					Questionário
				</Text>
				<Text size="small" weight="normal" variant="gray" marginBottom={16}>
					Essas informações ajudam a equipe médica a cuidar melhor de você, oferecendo mais segurança e tranquilidade durante o procedimento anestésico.
				</Text>

				<Text size="medium" weight="medium" marginBottom={16}>
					Selecione as suas condições de saúde
				</Text>
			</div>

			<div className="doca-flex-1 doca-overflow-y-auto doca-px-4">
				<div className="doca-flex doca-flex-wrap">
					{questionaryFields?.map(field => (
						<div key={field.key} className={`${isMobile ? 'doca-w-full' : 'doca-w-1/2'} doca-py-2`}>
							<label className="doca-checkbox__container doca-cursor-pointer doca-flex doca-items-center" htmlFor={field.key}>
								<input
									type="checkbox"
									className="doca-checkbox"
									checked={!!values[field.key]}
									onChange={() => onToggleField(field.key)}
									id={field.key}
								/>

								<p className="doca-checkbox__label doca-ml-2">
									{field.label}
								</p>
							</label>
						</div>
					))}
				</div>

				<div className={`doca-flex ${isMobile ? 'doca-flex-col' : ''} doca-gap-4 doca-mt-6`}>
					<div className="doca-form__field">
						<label className="doca-form__label">
							Peso
						</label>
						<div className="doca-form-control__icon-container doca-form-control__icon-container--right">
							<input
								type="text"
								className="doca-form-control"
								value={weight}
								onChange={onWeightChange}
								placeholder="00,00"
								inputMode="decimal"
								pattern="[0-9,]*"
							/>
							<span className="doca-form-control__text-right">
								kg
							</span>
						</div>
					</div>
					<div className="doca-form__field">
						<label className="doca-form__label">
							Altura
						</label>
						<div className="doca-form-control__icon-container doca-form-control__icon-container--right">
							<input
								type="tel"
								className="doca-form-control"
								value={height}
								onChange={onHeightChange}
								onKeyUp={keyUpOnlyNumber}
								placeholder="000"
							/>
							<span className="doca-form-control__text-right">
								cm
							</span>
						</div>
					</div>
				</div>
			</div>

			<div className="doca-mt-6 doca-mb-6 doca-px-4">
				<Button
					block
					size="large"
					variant={variant}
					type="button"
					onClick={onSubmit}
				>
					Continuar
				</Button>
			</div>
		</div>
	);
};

export default AnesthetistQuestionaryForm;
